/**
 * Canal éditeur du Tableau : la sidebar demande au canvas d'amener une colonne
 * sous les yeux (l'œil d'aperçu d'un item de la liste « Colonnes »).
 *
 * Un tableau large défile horizontalement : régler la cinquième colonne quand
 * on n'en voit que trois revient à travailler à l'aveugle. La position de
 * défilement n'est pas une prop persistée — c'est un état du DOM, d'où le canal
 * plutôt qu'un aller-retour par la data (même approche que
 * `carouselSlidesRegistry`).
 *
 * Registre module par instance de rendu : l'iframe de l'éditeur et le viewer
 * ont chacun leur bundle, donc leur propre Set.
 */

const listeners = new Set();

/**
 * @param {(blockId: string, columnIndex: number) => void} listener
 * @returns {() => void} désabonnement
 */
export function subscribeColumnPreview(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifyColumnPreview(blockId, columnIndex) {
  listeners.forEach((listener) => listener(blockId, columnIndex));
}
